// helpers
export function fmtDate(iso, tz = 'America/Toronto', opts = {}) {
  try {
    const d = new Date(iso);
    return d.toLocaleString('en-CA', { timeZone: tz, weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', ...opts });
  } catch { return iso; }
}

export function fmtTime(iso, tz = 'America/Toronto') {
  try {
    return new Date(iso).toLocaleString('en-CA', { timeZone: tz, hour: 'numeric', minute: '2-digit' });
  } catch { return iso; }
}

export function fmtDay(iso, tz = 'America/Toronto') {
  try {
    return new Date(iso).toLocaleDateString('en-CA', { timeZone: tz, weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
  } catch { return iso; }
}

export function ymd(date) {
  const d = date instanceof Date ? date : new Date(date);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

export const statusStyles = {
  pending:     { bg: 'bg-amber-50',    text: 'text-amber-700',    dot: 'bg-amber-500',    label: 'Pending' },
  confirmed:   { bg: 'bg-emerald-50',  text: 'text-emerald-700',  dot: 'bg-emerald-500',  label: 'Confirmed' },
  rescheduled: { bg: 'bg-blue-50',     text: 'text-blue-700',     dot: 'bg-blue-500',     label: 'Rescheduled' },
  cancelled:   { bg: 'bg-rose-50',     text: 'text-rose-700',     dot: 'bg-rose-500',     label: 'Cancelled' },
  completed:   { bg: 'bg-neutral-100', text: 'text-neutral-700',  dot: 'bg-neutral-500',  label: 'Completed' },
  no_show:     { bg: 'bg-orange-50',   text: 'text-orange-700',   dot: 'bg-orange-500',   label: 'No-show' },
};

export function StatusBadge({ status }) {
  const s = statusStyles[status] || statusStyles.pending;
  return (
    <span className={`inline-flex items-center gap-1.5 ${s.bg} ${s.text} text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
